/**
 * Bidding modes that can still be added to the given keyword rows, shared by the
 * create-strategy modal and the grid's "+" button so both apply the same rules.
 * Mode conflicts are read from the first row only; the multi-country rule applies
 * to every row of a bulk selection.
 */
export const getAvailableModes = (rows?: any[] | null): string[] => {
    const activations = Array.isArray(rows) ? rows[0]?.activations_details : null;

    // Active Mode is not offered for keywords targeting several countries
    // (nb_countries = ARRAY_LENGTH(country_code) in the keywords query).
    const hasMultiCountryKeyword = Array.isArray(rows) && rows.some((r: any) => (r?.nb_countries ?? 0) > 1);

    return ["Active Mode", "KO Bidding Manual", "KO Bidding Auto"].filter((mode) => {
        if (mode === "Active Mode" && hasMultiCountryKeyword) return false;

        const hasModeActive = activations?.some(
            (a: any) => a.status === true && a.mode?.startsWith(mode)
        );

        if (hasModeActive) return false;

        const hasManual = activations?.some(
            (a: any) => a.mode === "KO Bidding Manual" && a.status === true
        );

        const hasAuto = activations?.some(
            (a: any) => a?.mode?.startsWith("KO Bidding Auto") && a.status === true
        );

        if (hasManual && mode === "KO Bidding Auto") return false;
        if (hasAuto && mode === "KO Bidding Manual") return false;

        return true;
    });
};
